module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/nfl/icons_receiving_yds/blue-05ac641b0ed44cb0c25220df47e74eee.svg";